'use client';

import { useState } from 'react';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { useMegaMenu } from '@/hooks/use-mega-menu';
import { cn, NavigationMenu } from '@holistic/components';

import type { NavCategory } from '@/types/navigation';

import { TamirMegaMenu } from './tamir-mega-menu';

const NavList = ({ categories }: { categories: NavCategory[] | null }) => {
  const [openValue, setOpenValue] = useState('');

  return (
    <>
      {/* Menü açıkken sayfanın kalanını modal gibi karartan backdrop. */}
      {openValue && (
        <div
          aria-hidden
          className="animate-overlay-in fixed inset-x-0 top-16 z-40 h-screen bg-black/30"
        />
      )}
      <NavigationMenu
        viewport={false}
        value={openValue}
        onValueChange={setOpenValue}
      >
        <NavigationMenu.List className="gap-0.5">
          <NavigationMenuItem href="/" label="Ana Sayfa" />
          <NavigationMenuItem href="/hakkimizda" label="Hakkımızda" />
          <RepairRequestNav categories={categories} />
          <NavigationMenuItem
            href="/neden-yeniden-co"
            label="Neden yeniden.co?"
          />
          <NavigationMenuItem href="/blog" label="Blog" />
          <NavigationMenuItem href="/sss" label="SSS" />
          <NavigationMenuItem href="/iletisim" label="İletişim" />
        </NavigationMenu.List>
      </NavigationMenu>
    </>
  );
};

export default NavList;

const NavigationMenuItem = ({
  href,
  label,
}: {
  href: string;
  label: string;
}) => {
  const pathname = usePathname();
  const isActive =
    pathname === href || (href !== '/' && pathname.startsWith(href));

  return (
    <NavigationMenu.Item>
      <NavigationMenu.Link asChild>
        <Link
          href={href}
          className={cn(
            'relative px-2 py-2 text-[13px] font-medium whitespace-nowrap transition-colors duration-200 xl:px-3 xl:text-sm',
            'after:absolute after:inset-x-2 after:bottom-0 after:h-0.5 after:rounded-full after:transition-all after:duration-200 xl:after:inset-x-3',
            isActive
              ? 'text-primary after:bg-primary after:scale-x-100'
              : 'text-gray-600 after:scale-x-0 hover:text-gray-900 hover:after:scale-x-100 hover:after:bg-gray-300'
          )}
        >
          {label}
        </Link>
      </NavigationMenu.Link>
    </NavigationMenu.Item>
  );
};

const RepairRequestNav = ({
  categories,
}: {
  categories: NavCategory[] | null;
}) => {
  const pathname = usePathname();
  const isActive = pathname.startsWith('/talep');
  const { tree, prefetch } = useMegaMenu();

  if (!categories || categories.length === 0) return null;

  return (
    <NavigationMenu.Item>
      <NavigationMenu.Trigger
        onPointerEnter={prefetch}
        onFocus={prefetch}
        className={cn(
          'rounded-full px-2 py-1.5 text-[13px] font-semibold whitespace-nowrap transition-colors duration-200 xl:px-3 xl:text-sm',
          // Vurgulu hap sadece hover/açık menüde ya da /talep akışındayken görünür.
          'hover:bg-primary/8 hover:text-primary data-[state=open]:bg-primary/8 data-[state=open]:text-primary',
          isActive ? 'bg-primary/8 text-primary' : 'text-gray-600'
        )}
      >
        Tamir Talebi
      </NavigationMenu.Trigger>
      <NavigationMenu.Content className="animate-mega-in fixed! inset-x-0! top-16! z-50! mt-0! max-w-none! rounded-none! bg-white p-0! shadow-none! ring-0!">
        <TamirMegaMenu categories={categories} tree={tree} />
      </NavigationMenu.Content>
    </NavigationMenu.Item>
  );
};
